import React from "react";
import {
  Modal,
  Button as MantineButton,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { Button } from "@jem-open/jem-ui";

export interface ConfirmationModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  loading?: boolean;
  variant?: "default" | "danger";
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  opened,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  loading = false,
  variant = "default",
}) => {
  const theme = useMantineTheme();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      centered
      padding={32}
      size={577}
      styles={{
        modal: {
          borderRadius: "16px",
        },
      }}
    >
      <div className="flex flex-col gap-8">
        <div>
          <Text
            weight={700}
            style={{
              fontSize: "16px",
              color: theme.black,
              letterSpacing: "0.16px",
              marginBottom: "8px",
            }}
          >
            {title}
          </Text>
          <Text
            style={{
              fontSize: "14px",
              color: theme.black,
              lineHeight: "20px",
              opacity: 0.8,
            }}
          >
            {description}
          </Text>
        </div>
        <div className="flex gap-4 justify-end">
          <MantineButton
            variant="outline"
            onClick={onClose}
            styles={{
              root: {
                border: `1px solid ${theme.black}`,
                color: theme.black,
                borderRadius: "6px",
                fontWeight: 600,
                fontSize: "12px",
                height: "35px",
                minWidth: "118px",
                letterSpacing: "0.16px",
                textTransform: "capitalize",
              },
            }}
          >
            {cancelLabel}
          </MantineButton>
          <Button
            onClick={onConfirm}
            loading={loading}
            variant={variant === "danger" ? "destructive" : "primary"}
            className="min-w-[118px]"
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
